import {MAIN_BANNER_TYPE, SECOND_BANNER_TYPE} from '../../config/app';
import Sentry from 'lib/sentry';

const mapBannerData = (banners) => {
  return banners.map((banner) => ({
    img: banner.image_url,
    title: banner.title,
    url: banner.link,
    order: banner.order,
  }));
};

const initialState = {
  mainBanners: [],
  secondBanners: [],
};

const getters = {
  getBanners: (state, commit, rootState) => ({
    [MAIN_BANNER_TYPE]: mapBannerData(rootState.dataServer?.banners ?? []),
    [SECOND_BANNER_TYPE]: state.secondBanners,
  }),
};

const actions = {
  fetchBanners({commit}, {type}) {
    return this.$api
      .getBanners({type})
      .then(({data}) => {
        const banners = mapBannerData(data);

        if (type === SECOND_BANNER_TYPE) {
          commit('setSecondBanners', banners);
        }
      })
      .catch((e) => {
        if (type === SECOND_BANNER_TYPE) {
          commit('setSecondBanners', []);
        }
        Sentry.log('fetchBanners', e);
      });
  },
};

const mutations = {
  setSecondBanners(state, banners) {
    state.secondBanners = banners;
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
